import { Link as ReactLink } from 'react-router-dom';
import { Box, Button, Typography, useTheme } from '@mui/material';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import useFreeTrialStatus from '../../hooks/subscriptions/useFreeTrialStatus';
import { ROUTES } from '../../constants/global';
import { canUserManageSubscription } from '../../helpers/subscriptions';
import useUser from '../../hooks/global/useUser';

export const BANNER_HEIGHT = 45;

function FreeTrialBanner() {
  const { user } = useUser();
  const { daysRemaining, isBannerShown, hideBanner } = useFreeTrialStatus();
  const theme = useTheme();

  const canManageSubscription = canUserManageSubscription(user);

  if (!isBannerShown) return null;

  const Component = canManageSubscription ? ReactLink : Box;

  const days = Math.max(1, daysRemaining);
  const daysString = `${days} day${days > 1 ? 's' : ''}`;

  return (
    <Box
      bgcolor={theme.palette.primary.main}
      width="100vw"
      height={BANNER_HEIGHT}
      display="flex"
      justifyContent="center"
      alignItems="center">
      <Box
        component={Component}
        to={ROUTES.subscription}
        sx={{
          textDecoration: 'none',
        }}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h5" color="white">
            {daysString} left in your free trial.
          </Typography>
          {/* flex when md >, hidden when smaller */}
          {canManageSubscription && (
            <Box
              display={{ xs: 'none', sm: 'flex' }}
              gap={1}
              alignItems="center">
              <Typography
                variant="body2"
                color="white"
                marginLeft={1}
                sx={{
                  color: '#ffffff !important',
                }}>
                Subscribe now
                <Typography
                  variant="body2"
                  color="white"
                  display={{
                    xs: 'none',
                    md: 'inline',
                  }}
                  component="span"
                  sx={{ color: '#ffffff !important' }}>
                  {' '}
                  to keep access to your account
                </Typography>
              </Typography>
              <EastRoundedIcon sx={{ color: 'white' }} fontSize="small" />
            </Box>
          )}
        </Box>
      </Box>
      <Button
        onClick={hideBanner}
        sx={{
          position: 'absolute',
          right: '10px',
          display: 'flex',
          alignItems: 'center',
        }}>
        <CloseRoundedIcon sx={{ color: 'white' }} fontSize="small" />
      </Button>
    </Box>
  );
}

export default FreeTrialBanner;
